export class PedidoDeCompra {}
